import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ErrorComponent } from './pages/error/error.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  { path: 'factory-display', loadChildren: () => import('./pages/factory-display/factory-display.module').then(m => m.FactoryDisplayModule) },
  { path: 'factory-tv', loadChildren: () => import('./pages/factory-tv/factory-tv.module').then(m => m.FactoryTvModule) },
  { path: 'tv-app', loadChildren: () => import('./pages/tv-app/tv-app.module').then(m => m.TvAppModule) },
  { path: 'pair', loadChildren: () => import('./pages/pair/pair.module').then(m => m.PairModule) },
  { path: 'factory-touch', loadChildren: () => import('./pages/factory-touch/factory-touch.module').then(m => m.FactoryTouchModule) },
  { path: 'packing', loadChildren: () => import('./pages/packing/packing.module').then(m => m.PackingModule) },
  { path: 'driver-portal', loadChildren: () => import('./pages/driver-portal/driver-portal.module').then(m => m.DriverPortalModule) },
  { path: '**', component: ErrorComponent }
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadAllModules,
});
